import NotificationsContainer from './components/notifications-container';

export default NotificationsContainer;
